/**
 * Contact-phone selection helper.
 *
 * The clinic record carries two phone numbers per backend v0.7.4:
 *
 *   - `phone`         — clinic's main storefront line (general inquiries)
 *   - `billing_phone` — billing-inquiries line for the clinic's RCM
 *                       vendor (per-deployment YAML override; null when
 *                       not configured)
 *
 * Almost everywhere in the portal the user IS in a billing context —
 * paying a balance, asking about a charge, post-payment confusion.
 * `pickContactPhone()` returns `billing_phone` when configured, falling
 * back to `phone` otherwise. The one render site that DOESN'T use this
 * is `PayPageHeader`'s clinic identity strip — there the user is
 * reading "who is this charging me?" and the main line is the right
 * answer.
 *
 * Returns null when both fields are null, so callers can hide the
 * whole element rather than render a dead "tel:" link.
 */
import type { ClinicInfo } from '../api/types';

export function pickContactPhone(
  clinic: Pick<ClinicInfo, 'phone' | 'billing_phone'>,
): string | null {
  return clinic.billing_phone ?? clinic.phone ?? null;
}
